import { Routes } from '@/types/routes.enum';

import {
  createHasAskUrl,
  createNewestTopicUrl,
} from '@/utilites/algolia/create-algolia-urls';
import { createMostWatchedTopicUrl } from '@/utilites/algolia/create-algolia-urls';
import { createMostPopularTopicUrl } from '@/utilites/algolia/create-algolia-urls';
import { createCountyOfOriginUrl } from '@/utilites/algolia/create-algolia-urls';

import { createHasBidUrl } from '@/utilites/algolia/create-algolia-urls';
import { createBrandUrl } from '@/utilites/algolia/create-algolia-urls';

import { HeaderEnum } from '@/types/translations/HeaderEnum';
import { HeaderDropdownItem } from '@/types/props/components/layout';

import {
  User,
  ShoppingCart,
  Store,
  Briefcase,
  MessageCircle,
} from 'lucide-react';
import { CTAType } from '@/types/other';

const browseMenu: HeaderDropdownItem[] = [
  {
    title: HeaderEnum['browse_menu.status.status'],
    children: [
      {
        label: HeaderEnum['browse_menu.status.has_bids'],
        href: createHasBidUrl(),
      },
      {
        label: HeaderEnum['browse_menu.status.has_asks'],
        href: createHasAskUrl(),
      },
    ],
  },
  {
    title: HeaderEnum['browse_menu.main.brand'],
    children: [
      {
        label: 'Macallan',
        href: createBrandUrl('Macallan'),
      },
      {
        label: 'Ardbeg',
        href: createBrandUrl('Ardbeg'),
      },
      {
        label: 'Yamazaki',
        href: createBrandUrl('Yamazaki'),
      },
      {
        label: 'Chichibu',
        href: createBrandUrl('Chichibu'),
      },
      {
        label: 'Bowmore',
        href: createBrandUrl('Bowmore'),
      },
      {
        label: 'Springbank',
        href: createBrandUrl('Springbank'),
      },
      {
        label: 'Lagavulin',
        href: createBrandUrl('Lagavulin'),
      },
    ],
  },
  {
    title: HeaderEnum['browse_menu.main.countries'],
    children: [
      {
        label: HeaderEnum['browse_menu.countries.scotland'],
        href: createCountyOfOriginUrl('Scotland'),
      },
      {
        label: HeaderEnum['browse_menu.countries.france'],
        href: createCountyOfOriginUrl('France'),
      },
      {
        label: HeaderEnum['browse_menu.countries.ireland'],
        href: createCountyOfOriginUrl('Ireland'),
      },
      {
        label: HeaderEnum['browse_menu.countries.germany'],
        href: createCountyOfOriginUrl('Germany'),
      },
      {
        label: HeaderEnum['browse_menu.countries.japan'],
        href: createCountyOfOriginUrl('Japan'),
      },
      {
        label: HeaderEnum['browse_menu.countries.usa'],
        href: createCountyOfOriginUrl('USA'),
      },
      {
        label: HeaderEnum['browse_menu.countries.mexico'],
        href: createCountyOfOriginUrl('Mexico'),
      },
    ],
  },
  {
    title: HeaderEnum['browse_menu.main.topics'],
    children: [
      {
        label: HeaderEnum['browse_menu.topics.most_popular'],
        href: createMostPopularTopicUrl(),
      },
      {
        label: HeaderEnum['browse_menu.topics.most_watched'],
        href: createMostWatchedTopicUrl(),
      },
      {
        label: HeaderEnum['browse_menu.topics.new'],
        href: createNewestTopicUrl(),
      },
    ],
  },
];

const aboutMenu: HeaderDropdownItem[] = [
  {
    title: HeaderEnum['about_menu.about_menu'],
    children: [
      {
        label: HeaderEnum['about_menu.how_it_works'],
        href: Routes._HOW_IT_WORKS,
      },
      {
        label: HeaderEnum['about_menu.buyer_guide'],
        href: Routes._BUYER_GUIDE,
      },
      {
        label: HeaderEnum['about_menu.portfolio_guide'],
        href: Routes._PORTFOLIO_GUIDE,
      },
      {
        label: HeaderEnum['about_menu.authentication'],
        href: Routes._AUTHENTICATING,
      },
      {
        label: HeaderEnum['about_menu.bottle_condition'],
        href: Routes._CONDITION_GUIDE,
      },
      {
        label: HeaderEnum['about_menu.blog'],
        href: Routes._BLOG,
      },
      {
        label: HeaderEnum['about_menu.help'],
        href: Routes._HELP,
      },
    ],
  },
];

const sellMenu = (becomeASellerClick: () => void): HeaderDropdownItem[] => [
  {
    title: HeaderEnum['sell_menu.sell_menu'],
    children: [
      {
        label: HeaderEnum['sell_menu.become_a_seller'],
        onClick: becomeASellerClick,
      },
      {
        label: HeaderEnum['sell_menu.seller_guide'],
        href: Routes._SELLER_GUIDE,
      },
      {
        label: HeaderEnum['sell_menu.has_bids'],
        href: createHasBidUrl(),
      },
      {
        label: HeaderEnum['sell_menu.shipping_guide'],
        href: Routes._SHIPPING_GUIDE,
      },
      {
        label: HeaderEnum['sell_menu.bottle_condition'],
        href: Routes._CONDITION_GUIDE,
      },
    ],
  },
];

const dashboardMenuSettings = [
  {
    label: HeaderEnum['dashboard_menu.settings_menu.your_account'],
    tFallback: 'Your Account',
    action: '/dashboard/settings',
    actionType: 'link',
    extraIcon: User,
    translate: true,
  },
  {
    label: HeaderEnum['dashboard_menu.settings_menu.buyer_profile'],
    tFallback: 'Buyer Profile',
    action: '/dashboard/settings/buyer-profile',
    actionType: 'link',
    extraIcon: ShoppingCart,
    translate: true,
  },
  {
    label: HeaderEnum['dashboard_menu.settings_menu.seller_profile'],
    tFallback: 'Seller Profile',
    action: '/dashboard/settings/seller-profile',
    actionType: 'link',
    extraIcon: Store,
    translate: true,
  },
  {
    label: HeaderEnum['dashboard_menu.settings_menu.services'],
    tFallback: 'Services',
    action: '/dashboard/settings/services',
    actionType: 'link',
    extraIcon: Briefcase,
    translate: true,
  },
  {
    label: HeaderEnum['dashboard_menu.settings_menu.feedback'],
    tFallback: 'Feedback',
    action: '/dashboard/settings/feedback',
    actionType: 'link',
    extraIcon: MessageCircle,
    translate: true,
  },
];

const headerItemConstants = {
  browseMenu,
  aboutMenu: aboutMenu,
  sellMenu,
  dashboardMenuSettings,
};

export default headerItemConstants;
